import styled from 'styled-components';

export const IconButton = styled.button`
  border: none;
  background: none;
  cursor: pointer;
`;
